import { render } from "./business-license.vue?vue&type=template&id=66f13dd4&scoped=true"
import script from "./business-license.vue?vue&type=script&lang=js"
export * from "./business-license.vue?vue&type=script&lang=js"

import "./business-license.vue?vue&type=style&index=0&id=66f13dd4&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f13dd4"]])

export default __exports__